/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Sleep_GoodInputs */

const en_us2_workout_sleep_good = /** @type {(inputs: Workout_Sleep_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Good`)
};

const pt_br2_workout_sleep_good = /** @type {(inputs: Workout_Sleep_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bom`)
};

const es_419_workout_sleep_good = /** @type {(inputs: Workout_Sleep_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bueno`)
};

const pt_pt2_workout_sleep_good = /** @type {(inputs: Workout_Sleep_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bom`)
};

const fr_fr2_workout_sleep_good = /** @type {(inputs: Workout_Sleep_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bon`)
};

const de_de2_workout_sleep_good = /** @type {(inputs: Workout_Sleep_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gut`)
};

const it_it2_workout_sleep_good = /** @type {(inputs: Workout_Sleep_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buono`)
};

/**
* | output |
* | --- |
* | "Good" |
*
* @param {Workout_Sleep_GoodInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_sleep_good = /** @type {((inputs?: Workout_Sleep_GoodInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Sleep_GoodInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_sleep_good(inputs)
	if (locale === "es-419") return es_419_workout_sleep_good(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_sleep_good(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_sleep_good(inputs)
	if (locale === "de-DE") return de_de2_workout_sleep_good(inputs)
	if (locale === "it-IT") return it_it2_workout_sleep_good(inputs)
	return en_us2_workout_sleep_good(inputs)
});
export { workout_sleep_good as "workout.sleep_good" }